import React from "react";

/* MENSAJE USADO EN EL MODAL */
function MensajeNotFound({motivo}) {  
  
  return (
    <>
        <p className="txt-left mt-3 p-0">         
          {motivo}        
        </p>      
    </>
  );
}

export default MensajeNotFound;
